module.exports = __webpack_public_path__ + "static/media/closeicon.55139b34.svg";